import { style } from 'app/assets/styles'
import { Link } from 'app/common/link'
import { styleText, Text } from 'app/common/typography'
import { kingdomItems } from 'app/kingdom'
import React, { Component, Fragment } from 'react'
import type { IntlShape } from 'react-intl'
import { FormattedMessage, injectIntl } from 'react-intl'
import { colors as oldColors } from 'shared/assets/styles'
import { colors } from 'app-v2/design-systems/theme/colors'
import styled from 'styled-components'
import type { MenuListItem } from 'app/common/layout/menu'
import { COLOR } from 'app-v2/design-tokens'
import { CATEGORY_ID, featureCodes } from 'shared/utils'

const { grey, lightGrey, shadow, yellow } = oldColors

type Props = {
    authenticated?: boolean,
    logout: () => void,
    logoutDone: (params: { isGlobal: boolean }) => void,
    intl: IntlShape,
    availableFeatures: string[]
}

class KingdomPopin extends Component<Props> {
    logout = async () => {
        const { logout, logoutDone } = this.props
        await logout()
        logoutDone({ isGlobal: false })
    }

    render() {
        const { authenticated, intl, availableFeatures } = this.props
        const blazonsIsAvailable = availableFeatures.includes(
            featureCodes.KINGDOM_MENU_BLAZON
        )

        return (
            <Fragment>
                <Triangle />
                <KingdomPopinContainer>
                    {authenticated ? (
                        <Content>
                            <FormattedMessage id="navigation.account.statusMessage.connected">
                                {(text: string) => (
                                    <StyledText color={grey}>{text}</StyledText>
                                )}
                            </FormattedMessage>
                            {kingdomItems
                                .filter(k =>
                                    k.categoryId === CATEGORY_ID.BLAZON
                                        ? blazonsIsAvailable
                                        : k.inMenu
                                )
                                .map((item: MenuListItem, index: number) => {
                                    const { routeId, title } = item
                                    let url = intl.formatMessage({
                                        id: 'routes.kingdom.dashboard'
                                    })
                                    if (routeId) {
                                        url = `${url}/${intl.formatMessage({
                                            id: routeId
                                        })}`
                                    }
                                    return (
                                        <FormattedMessage
                                            key={index}
                                            id={title}>
                                            {(text: string) => (
                                                <StyledLink
                                                    border="true"
                                                    url={url}>
                                                    {text}
                                                </StyledLink>
                                            )}
                                        </FormattedMessage>
                                    )
                                })}
                            <FormattedMessage id="kingdom.logout.button.local.label">
                                {(text: string) => (
                                    <StyledButtonMedium
                                        background={colors.fieryRed}
                                        color={COLOR.SECONDARY}
                                        url={intl.formatMessage({
                                            id: 'routes.signup'
                                        })}
                                        onClick={this.logout}
                                        hasmargin="true">
                                        {text}
                                    </StyledButtonMedium>
                                )}
                            </FormattedMessage>
                        </Content>
                    ) : (
                        <Content>
                            <FormattedMessage id="signup.login.button">
                                {(text: string) => (
                                    <StyledButtonMedium
                                        background={yellow}
                                        url={intl.formatMessage({
                                            id: 'routes.signin'
                                        })}>
                                        {text}
                                    </StyledButtonMedium>
                                )}
                            </FormattedMessage>
                            <FormattedMessage id="header.kingdom.popin.no.account.label">
                                {(text: string) => (
                                    <StyledText border>{text}</StyledText>
                                )}
                            </FormattedMessage>
                            <FormattedMessage id="header.kingdom.popin.signup.label">
                                {(text: string) => (
                                    <StyledButtonMedium
                                        background="white"
                                        border={yellow}
                                        color={yellow}
                                        url={intl.formatMessage({
                                            id: 'routes.signup'
                                        })}>
                                        {text}
                                    </StyledButtonMedium>
                                )}
                            </FormattedMessage>
                        </Content>
                    )}
                </KingdomPopinContainer>
            </Fragment>
        )
    }
}

const Triangle = styled.i`
    position: absolute;
    top: 73px;
    left: 25px;
    width: 25px;
    height: 25px;
    background-color: white;
    z-index: 2;
    border-top-right-radius: 30%;
    transform: rotate(-45deg);
    &:before {
        transform: rotate(-135deg) skewX(-45deg) translate(0, -50%);
    }
    &:after {
        transform: rotate(135deg) skewY(-45deg) translate(50%);
    }
`

const KingdomPopinContainer = styled.div`
    position: absolute;
    top: 80px;
    width: 260px;
    left: -200px;
    padding: 30px;
    border-radius: 12px;
    background-color: white;
    box-shadow: 0 0 50px ${shadow};
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const StyledButtonMedium = styled(Link)`
    ${style.buttonMedium};
    border: none;
    width: calc(100% - 60px);
    margin-left: 30px;
    margin-right: 30px;
    border: solid 1px ${props => props.border};
    ${props => (props.hasmargin ? 'margin-top: 50px' : '')};
`

const StyledText = styled(Text)`
    ${props =>
        props.border
            ? `
            border-top: 1px solid ${lightGrey}; 
            margin-top: 20px;
            margin-bottom: 20px;
            padding-top: 20px;
        `
            : `
            border-bottom: 1px solid ${lightGrey};
            padding-bottom: 10px;
            width: 100%;
        `};
`

const StyledLink = styled(Link)`
    ${styleText};
    ${props => (props.border ? `border-bottom: 1px solid ${lightGrey}` : '')};
    padding: 10px 0;
    width: 100%;
`

const KingdomPopinComponent = injectIntl(KingdomPopin)

export { KingdomPopinComponent }
